"use client";
import React from 'react';
import Link from 'next/link';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { useLanguage } from '@/context/LanguageContext';


export default function NotFound() {
    const { t } = useLanguage();

    return (
        <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '6rem 2rem' }}>
            <div style={{ textAlign: 'center', maxWidth: '800px' }}>
                <div style={{
                    fontSize: '12rem',
                    fontWeight: 950,
                    lineHeight: 1,
                    background: 'linear-gradient(180deg, var(--primary) 0%, #f1f5f9 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    opacity: 0.15,
                    marginBottom: '-4rem'
                }}>
                    404
                </div>
                <h1 style={{ fontSize: 'clamp(2.5rem, 6vw, 4rem)', fontWeight: 900, color: '#0f172a', marginBottom: '1.5rem', letterSpacing: '-0.05em' }}>
                    {t('node_decommissioned') || 'Page Not Found'}
                </h1>
                <p style={{ fontSize: '1.25rem', color: '#64748b', marginBottom: '4rem', lineHeight: '1.8', maxWidth: '600px', margin: '0 auto 4rem' }}>
                    {t('404_desc') || 'The requested utility is currently unavailable. Return to our homepage to find a functional tool.'}
                </p>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '1.5rem',
                    marginBottom: '5rem',
                    textAlign: 'left'
                }}>
                    <Link href="/tools/text-utilities" style={{ padding: '2rem', background: '#f8fafc', borderRadius: '24px', border: '1px solid #e2e8f0', textDecoration: 'none' }}>
                        <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>🔡</div>
                        <div style={{ fontWeight: 800, color: '#0f172a' }}>{t('text_utilities')}</div>
                        <div style={{ fontSize: '0.85rem', color: '#64748b' }}>38+ formatting tools</div>
                    </Link>
                    <Link href="/tools/financial-tools" style={{ padding: '2rem', background: '#f8fafc', borderRadius: '24px', border: '1px solid #e2e8f0', textDecoration: 'none' }}>
                        <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>💰</div>
                        <div style={{ fontWeight: 800, color: '#0f172a' }}>{t('cat_financial') || 'Financial Suite'}</div>
                        <div style={{ fontSize: '0.85rem', color: '#64748b' }}>40+ financial tools</div>
                    </Link>
                    <Link href="/tools/security-tools" style={{ padding: '2rem', background: '#f8fafc', borderRadius: '24px', border: '1px solid #e2e8f0', textDecoration: 'none' }}>
                        <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>🛡️</div>
                        <div style={{ fontWeight: 800, color: '#0f172a' }}>{t('cat_security') || 'Security Pro'}</div>
                        <div style={{ fontSize: '0.85rem', color: '#64748b' }}>Encryption & auditing</div>
                    </Link>
                </div>

                <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Link href="/" className="btn-primary" style={{ padding: '1.25rem 3rem', fontSize: '1.1rem', borderRadius: '100px' }}>
                        {t('nav_home')}
                    </Link>
                    <Link href="/tools" style={{
                        padding: '1.25rem 3rem',
                        fontSize: '1.1rem',
                        fontWeight: 800,
                        color: '#0f172a',
                        border: '2px solid #0f172a',
                        borderRadius: '100px',
                        background: 'transparent'
                    }}>
                        {t('all_tools')}
                    </Link>
                </div>
            </div>
        </main>
    );
}
